import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";
import { usePreviewData } from "@/features/previews/shared/hooks/usePreviewData";
import {
  usePreviewValidation,
  createValidationRules,
} from "@/features/previews/shared/hooks/usePreviewValidation";
import { ListLinksPreviewTranslations, UseListLinksDataResult } from "../types";

export const useListLinksData = (props: QRProps<"listoflinks">): UseListLinksDataResult => {
  const { data, isInitPreview, context } = usePreviewData(props);
  const translations = (props.previewTranslations?.["listoflinks"] ||
    {}) as ListLinksPreviewTranslations;

  usePreviewValidation({
    rules: [createValidationRules.arrayNotEmpty(() => data?.links || [])],
    dependencies: [data?.links],
    context: context as QREditorContextProps<any>,
    isInitPreview,
  });

  return {
    translations,
    isInitialPreview: isInitPreview,
    data,
  };
};
